var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0.00012207C6.71566 0.00012207 0 6.71578 0 15.0001C0 23.2844 6.71566 30.0001 15 30.0001C23.2843 30.0001 30 23.2844 30 15.0001C29.9999 6.71578 23.2842 0.00012207 15 0.00012207ZM10.9979 22.2519H7.70455V11.6119H10.9979V22.2519ZM9.33556 10.2185C8.25997 10.2185 7.38802 9.33941 7.38802 8.25521C7.38802 7.17089 8.26009 6.29188 9.33556 6.29188C10.411 6.29188 11.283 7.17089 11.283 8.25521C11.283 9.33947 10.4111 10.2185 9.33556 10.2185ZM23.3399 22.2519H20.0625V16.6668C20.0625 15.1349 19.4807 14.2798 18.2694 14.2798C16.9511 14.2798 16.2624 15.1704 16.2624 16.6668V22.2519H13.1037V11.6119H16.2624V13.0449C16.2624 13.0449 17.2126 11.2873 19.4687 11.2873C21.7249 11.2873 23.34 12.6649 23.34 15.5148L23.3399 22.2519Z",
    fill: "url(#paint0_linear_1_405)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_405",
    x1: 4.39338,
    y1: 4.39351,
    x2: 25.6066,
    y2: 25.6067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.322fe865e40d0e1b2e41c824dc7bc4cc.svg";
export { ForwardRef as ReactComponent };